import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
  makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Page from '../../../../components/Layout/Page';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import Request from '../../../../requests/api/user';
import AdminEditForm from './UserEditForm';
import Header from './Header';
import RequestRole from '../../../../requests/api/role';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function AdminEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [admin, setAdmin] = useState();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const getRoles = async () => {
      const response = await RequestRole.getRolesPerPage(0, 1000, '');
      if (response.success) {
        const data = await response.data.data.roles;
        setRoles(data);
      }
    };

    getRoles();
  }, []);

  useEffect(() => {
    const getAdmin = async () => {
      const res = await Request.getUserById(props.match.params.id);
      const response = res.data;
      if (isMountedRef.current) {
        setAdmin(response.data.user);
      }
    };

    getAdmin();
    // eslint-disable-next-line
  }, [props]);

  if (!admin) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Template Title | Editar Admin"
    >
      <Container maxWidth="lg">
        <Header />
        <Box mt={3}>
          <AdminEditForm admin={admin} roles={roles} />
        </Box>
      </Container>
    </Page>
  );
}

AdminEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(AdminEditView);
